function eqHeight() {
    $.fn.extend({
        equalHeights: function() {
            var top = 0;
            var row = [];
            var classname = ('equalHeights' + Math.random()).replace('.', '');
            $(this).each(function() {
                var thistop = $(this).offset().top;
                if (thistop > top) {
                    $('.' + classname).removeClass(classname);
                    top = thistop
                }
                $(this).addClass(classname);
                $(this).height('auto');
                var h = (Math.max.apply(null, $('.' + classname).map(function() {
                    return $(this).height()
                }).get()));
                $('.' + classname).height(h)
            }).removeClass(classname)
        }
    })
    $(".powders-design-list .design-detail h3").equalHeights();
    $(".powders-design-list .design-detail h5").equalHeights();
    $(".powders-design-list .design-detail").equalHeights();
    $(".powders-design-list .design-detail p").equalHeights();
    $(".slide-content h5").equalHeights();
    $(".slide-content h3.content-title").equalHeights();
    $(".seller-slider .slide-img").equalHeights();
    $(".powders-design-list li i").equalHeights();
    $(".slide-item .slide-img").equalHeights();
    $(".bar-slider .slide-content p").equalHeights();
    $(".collection-listing .product-card__title").equalHeights();
    $(".collection-listing .product-card .tag-saving h5").equalHeights();
    $(".collection-listing .medium-up--one-third").equalHeights();
    $(".benefits-section .card-listing .card-wrapper .image-block").equalHeights();
}

function powderListSlider() {
    if ($('.powders-design-list').length) {
        $('.powders-design-list').owlCarousel({
            responsiveClass: !0,
            loop: !1,
            nav: !0,
            responsive: {
                0: {
                    items: 1,
                },
                481: {
                    items: 2,
                },
                992: {
                    items: 5,
                    mouseDrag: !1,
                    touchDrag: !1,
                    nav: !1,
                }
            }
        })
    }
}
$(document).ready(function() {
    $(document).on("click", ".bold-ro__recurring-radio-btn.bold-ro__subscribe-radio-btn", function() {
        var classes = $("div.btn-wrap button").attr('class');
        var userClass = classes.match(/bold-ro__custombutton\-\d+/gi)[0];
        $("div.btn-wrap button." + userClass).addClass("customButton")
    })
    eqHeight();
    $("a[href='#']").click(function(e) {
        e.preventDefault()
    });
    powderListSlider()
});

function banner_mobile() {
    var get_copy = $(".banner-content  .title-price-wrap").html();
    $(window).on('load', function() {
        if ($(window).width() < 768) {
            $(".banner-inner .banner-img-slider").append(get_copy)
        }
    })
}

function dropdown_arrow() {
    $('.single-option-selector').click(function() {
        $(this).toggleClass('open')
    })
}
$(document).ready(function() {
    banner_mobile();
    dropdown_arrow();
    /* promo-banner 21-01-2021 */

    var isSlickLoaded = (typeof $.fn.Slick !== 'undefined');
    if (isSlickLoaded) {
        slider();
    }

    function slider() {
        $('.promo-banner').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            autoplay: true,
            cssEase: 'ease-in-out',
            autoplaySpeed: 2000,
        });
    }
    owlslider();

    function owlslider() {
        if (typeof owlCarousel === 'function') {
            $('.seller-slider').owlCarousel({
                loop: !1,
                margin: 10,
                nav: !0,
                dots: !1,
                responsive: {
                    0: {
                        items: 1
                    },
                    600: {
                        items: 3
                    },
                    1024: {
                        items: 4
                    },
                    1200: {
                        items: 5
                    }
                }
            });
            $('.bar-slider').owlCarousel({
                loop: !1,
                margin: 10,
                nav: !0,
                dots: !1,
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2
                    },
                    1024: {
                        items: 3
                    }
                }
            });
            $('.read-slider').owlCarousel({
                loop: !1,
                margin: 10,
                nav: !0,
                dots: !1,
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2
                    },
                    1025: {
                        items: 3
                    }
                }
            });
        }
    }

    if($('.flavour-dropdown').length > 0 ){
      $('.flavour-dropdown').select2({
          minimumResultsForSearch: Infinity,
          closeOnSelect: !0,
          placeholder: {
              id: '-1',
              text: 'Choose a Flavour'
          }
      });
      $('.flavour-dropdown').each(function() {
          $(this).select2({
              minimumResultsForSearch: Infinity,
              closeOnSelect: !0,
              dropdownParent: $(this).closest('.flavour-dropdown-wrap'),
              placeholder: {
                  id: '-1',
                  text: 'Choose a Flavour'
              }
          }).on('change', function() {
              var selectVal = $(this).val();
              $(".product-banner h1").css("color", selectVal);
              $(".product-banner .price-label").css("color", selectVal);
              $(".product-info-section h3").css("color", selectVal)
          })
      });
    }
    $('.del-title').click(function() {
        $('.delivery-block').not($(this).parent('.delivery-block')).removeClass('open')
        $('.del-detail').not($(this).siblings('.del-detail')).slideUp();
        $(this).siblings('.del-detail').slideToggle();
        $(this).parent('.delivery-block').toggleClass('open')
    });
});
$(window).resize(function() {
    eqHeight();
    banner_mobile();
    dropdown_arrow()
});
$(window).on('load', function() {
    eqHeight();
    banner_mobile();
    dropdown_arrow()
});